import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { Notify } from "../../Handlers/Notifications";
import { InterActive } from "../../utilities/ViewModelStructure";
import { start } from "repl";

export class ReportsVM extends InterActive{
    private data:{id:string , device_name:string , employee_key:string , employee_name:string ,log:string, created_at:string}[] = [] 
    private from:string = ''
    private to:string = ''
    private finished :boolean = false
    private refresh:boolean = false
    private started:boolean = false

    public get Data():{id:string , device_name:string , employee_key:string , employee_name:string ,log:string, created_at:string}[]{ return this.data }
    public get From():string{ return this.from }
    public get To():string { return this.to }
    public get Refresh():boolean{ return this.refresh }

    public set From(value:string){ this.from = value; this.update() }
    public set To(value:string ){ this.to = value; this.update() }

    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getReports({})
                    if(response){
                        if(response.status=== HttpStatusCode.Ok){
                            if(response.data.status){
                                this.data = [...response.data.data]
                                this.refresh = false
                                this.update()
                            }else  Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else   Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch {   Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
            }
        )
    }

    public searchData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getReports({from:this.from , to:this.to })
                    if(response){
                        if(response.status=== HttpStatusCode.Ok){
                            if(response.data.status){
                                this.data = [...response.data.data]
                                this.update()
                            }else  Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else   Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch {   Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
            }
        )
    }

    public async addData(){
        if(!this.started){
            this.started = true
            if(!this.finished){
                try{
                    const response = await ApiRequest.getReports({from:this.from , to:this.to , id:this.data.length>0?this.data[this.data.length-1].id:undefined})

                    if(response){
                        if(response.status=== HttpStatusCode.Ok){
                            if(response.data.status){
                                if(response.data.data.length === 0)
                                {
                                    this.finished = true
                                    this.update()
                                }else {
                                    this.data = [...this.data,...response.data.data]
                                    this.update()
                                }
                            }else  {
                                if(response.data.error_code == 'D0001'){
                                    this.finished = true
                                    this.update()
                                }
                                else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                            }
                        }else Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{ Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
            }
        }
    }

}